import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, vModelText as _vModelText, withDirectives as _withDirectives, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white add-user-card" }
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-md-6 mb-3" }
const _hoisted_5 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_6 = { class: "form-check-size border rounded-3 p-2" }
const _hoisted_7 = { class: "form-check form-check-inline radio radio-primary" }
const _hoisted_8 = { class: "form-check form-check-inline radio radio-primary" }
const _hoisted_9 = { class: "form-check form-check-inline radio radio-primary" }
const _hoisted_10 = { class: "form-check form-check-inline radio radio-primary" }
const _hoisted_11 = { class: "col-md-4" }
const _hoisted_12 = { class: "form-check-size border rounded-3 p-2" }
const _hoisted_13 = { class: "form-check form-check-inline radio radio-primary" }
const _hoisted_14 = { class: "form-check form-check-inline radio radio-primary" }
const _hoisted_15 = { class: "col-md-6 mb-3" }
const _hoisted_16 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_17 = { class: "col-md-4 mb-3" }
const _hoisted_18 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_19 = { class: "col-md-4 mb-3" }
const _hoisted_20 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_21 = {
  key: 0,
  class: "col-md-6 mb-3"
}
const _hoisted_22 = { class: "row" }
const _hoisted_23 = { class: "col-md-6 mb-3" }
const _hoisted_24 = { class: "form-check form-switch" }
const _hoisted_25 = { class: "col-md-6 mb-3" }
const _hoisted_26 = { class: "form-check form-switch" }
const _hoisted_27 = {
  key: 1,
  class: "col-md-7 mb-3"
}
const _hoisted_28 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_29 = { class: "form-check-size border rounded-3 p-2" }
const _hoisted_30 = { class: "form-check form-check-inline radio radio-primary" }
const _hoisted_31 = { class: "form-check form-check-inline radio radio-primary" }
const _hoisted_32 = { class: "form-check form-check-inline radio radio-primary" }
const _hoisted_33 = {
  key: 2,
  class: "row"
}
const _hoisted_34 = { class: "border border-primary mb-10" }
const _hoisted_35 = {
  class: "row d-flex align-items-center justify-content-between fw-bold py-2",
  style: {"background-color":"#0a59a4"}
}
const _hoisted_36 = { class: "col-md-5" }
const _hoisted_37 = { class: "d-flex float-end" }
const _hoisted_38 = ["disabled"]
const _hoisted_39 = { class: "col-md-5 mb-3" }
const _hoisted_40 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_41 = ["onUpdate:modelValue"]
const _hoisted_42 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_43 = { class: "col-md-5 mb-3" }
const _hoisted_44 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_45 = ["onUpdate:modelValue"]
const _hoisted_46 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_47 = { class: "col-md-2 mb-3" }
const _hoisted_48 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_49 = ["onClick"]
const _hoisted_50 = { class: "col-md-12 mt-3" }
const _hoisted_51 = { class: "d-flex align-items-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Form, {
        ref: "champsLibreForm",
        onSubmit: _ctx.addChampsLibre,
        "validation-schema": _ctx.champsLibreSchema
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _cache[14] || (_cache[14] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Type de champs descriptif ", -1)),
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createVNode(_component_Field, {
                      class: "form-check-input",
                      id: "radioinline2",
                      modelValue: _ctx.typeChampsLibre,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.typeChampsLibre) = $event)),
                      type: "radio",
                      name: "typeChamp",
                      value: "text"
                    }, null, 8, ["modelValue"]),
                    _cache[10] || (_cache[10] = _createElementVNode("label", {
                      class: "form-check-label mb-0",
                      for: "radioinline2"
                    }, "Texte", -1))
                  ]),
                  _createElementVNode("div", _hoisted_8, [
                    _createVNode(_component_Field, {
                      class: "form-check-input",
                      id: "radioinline3",
                      modelValue: _ctx.typeChampsLibre,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.typeChampsLibre) = $event)),
                      type: "radio",
                      name: "typeChamp",
                      value: "date"
                    }, null, 8, ["modelValue"]),
                    _cache[11] || (_cache[11] = _createElementVNode("label", {
                      class: "form-check-label mb-0",
                      for: "radioinline3"
                    }, "Date", -1))
                  ]),
                  _createElementVNode("div", _hoisted_9, [
                    _createVNode(_component_Field, {
                      class: "form-check-input",
                      id: "radioinline4",
                      modelValue: _ctx.typeChampsLibre,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.typeChampsLibre) = $event)),
                      type: "radio",
                      name: "typeChamp",
                      value: "number"
                    }, null, 8, ["modelValue"]),
                    _cache[12] || (_cache[12] = _createElementVNode("label", {
                      class: "form-check-label mb-0",
                      for: "radioinline4"
                    }, "Nombre", -1))
                  ]),
                  _createElementVNode("div", _hoisted_10, [
                    _createVNode(_component_Field, {
                      class: "form-check-input",
                      id: "radioinline5",
                      modelValue: _ctx.typeChampsLibre,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.typeChampsLibre) = $event)),
                      type: "radio",
                      name: "typeChamp",
                      value: "boolean"
                    }, null, 8, ["modelValue"]),
                    _cache[13] || (_cache[13] = _createElementVNode("label", {
                      class: "form-check-label mb-0",
                      for: "radioinline5"
                    }, "Indicateur", -1))
                  ])
                ]),
                _createVNode(_component_ErrorMessage, {
                  name: "typeChamp",
                  class: "text-danger"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _cache[17] || (_cache[17] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Le champ est obligatoire ? ", -1)),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _createVNode(_component_Field, {
                    class: "form-check-input",
                    id: "radioinli1",
                    modelValue: _ctx.estObligatoire,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.estObligatoire) = $event)),
                    type: "radio",
                    name: "estObligatoire",
                    value: true
                  }, null, 8, ["modelValue"]),
                  _cache[15] || (_cache[15] = _createElementVNode("label", {
                    class: "form-check-label mb-0",
                    for: "radioinli1"
                  }, "Oui", -1))
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _createVNode(_component_Field, {
                    class: "form-check-input",
                    id: "radioinli2",
                    modelValue: _ctx.estObligatoire,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.estObligatoire) = $event)),
                    type: "radio",
                    name: "estObligatoire",
                    value: false
                  }, null, 8, ["modelValue"]),
                  _cache[16] || (_cache[16] = _createElementVNode("label", {
                    class: "form-check-label mb-0",
                    for: "radioinli2"
                  }, "Non", -1))
                ]),
                _createVNode(_component_ErrorMessage, {
                  name: "estObligatoire",
                  class: "text-danger"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("div", _hoisted_16, [
                _cache[18] || (_cache[18] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                  _createTextVNode(" Nom du champ "),
                  _createElementVNode("span", { class: "text-danger" }, "*")
                ], -1)),
                _createVNode(_component_Field, {
                  name: "nomChamp",
                  type: "text",
                  class: "form-control shadow-none fs-md-15 text-black",
                  placeholder: "Entrer le nom du champ"
                }),
                _createVNode(_component_ErrorMessage, {
                  name: "nomChamp",
                  class: "text-danger"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, [
                _cache[19] || (_cache[19] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                  _createTextVNode(" Libellé du champ"),
                  _createElementVNode("span", { class: "text-danger" }, "*")
                ], -1)),
                _createVNode(_component_Field, {
                  name: "libelleChamp",
                  type: "text",
                  class: "form-control shadow-none fs-md-15 text-black",
                  placeholder: "Entrer le libellé"
                }),
                _createVNode(_component_ErrorMessage, {
                  name: "libelleChamp",
                  class: "text-danger"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("div", _hoisted_20, [
                _cache[20] || (_cache[20] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Valeur Par Défaut ", -1)),
                _createVNode(_component_Field, {
                  name: "valeurParDefaut",
                  type: "text",
                  class: "form-control shadow-none fs-md-15 text-black",
                  placeholder: "Entrer la valeur"
                }),
                _createVNode(_component_ErrorMessage, {
                  name: "valeurParDefaut",
                  class: "text-danger"
                })
              ])
            ]),
            (_ctx.typeChampsLibre == 'date')
              ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                  _createElementVNode("div", _hoisted_22, [
                    _createElementVNode("div", _hoisted_23, [
                      _cache[21] || (_cache[21] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Date du jour par défaut ", -1)),
                      _createElementVNode("div", _hoisted_24, [
                        _createVNode(_component_Field, {
                          name: "defaultDate",
                          class: "form-check-input",
                          id: "today",
                          type: "checkbox"
                        })
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_25, [
                      _cache[22] || (_cache[22] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Avec heure ", -1)),
                      _createElementVNode("div", _hoisted_26, [
                        _createVNode(_component_Field, {
                          name: "avecHeure",
                          class: "form-check-input",
                          id: "heure",
                          type: "checkbox"
                        })
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.typeChampsLibre == 'name')
              ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                  _createElementVNode("div", _hoisted_28, [
                    _cache[26] || (_cache[26] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Mode de saisie ", -1)),
                    _createElementVNode("div", _hoisted_29, [
                      _createElementVNode("div", _hoisted_30, [
                        _createVNode(_component_Field, {
                          class: "form-check-input",
                          id: "radioinlin2",
                          modelValue: _ctx.modeSaisie,
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.modeSaisie) = $event)),
                          type: "radio",
                          name: "modeSaisie",
                          value: "keywordValueList"
                        }, null, 8, ["modelValue"]),
                        _cache[23] || (_cache[23] = _createElementVNode("label", {
                          class: "form-check-label mb-0",
                          for: "radioinlin2"
                        }, "Liste simple", -1))
                      ]),
                      _createElementVNode("div", _hoisted_31, [
                        _createVNode(_component_Field, {
                          class: "form-check-input",
                          id: "radioinlin3",
                          modelValue: _ctx.modeSaisie,
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.modeSaisie) = $event)),
                          type: "radio",
                          name: "modeSaisie",
                          value: "keywordKeyValueList"
                        }, null, 8, ["modelValue"]),
                        _cache[24] || (_cache[24] = _createElementVNode("label", {
                          class: "form-check-label mb-0",
                          for: "radioinlin3"
                        }, "Liste avec libellés", -1))
                      ]),
                      _createElementVNode("div", _hoisted_32, [
                        _createVNode(_component_Field, {
                          class: "form-check-input",
                          id: "radioinlin4",
                          modelValue: _ctx.modeSaisie,
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.modeSaisie) = $event)),
                          type: "radio",
                          name: "modeSaisie",
                          value: "keywordExternalRef"
                        }, null, 8, ["modelValue"]),
                        _cache[25] || (_cache[25] = _createElementVNode("label", {
                          class: "form-check-label mb-0",
                          for: "radioinlin4"
                        }, "Référentiel externe", -1))
                      ])
                    ]),
                    _createVNode(_component_ErrorMessage, {
                      name: "modeSaisie",
                      class: "text-danger"
                    })
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.typeChampsLibre == 'name' && (_ctx.modeSaisie == 'keywordKeyValueList' || _ctx.modeSaisie == 'keywordValueList'))
              ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                  _createElementVNode("div", _hoisted_34, [
                    _createElementVNode("div", _hoisted_35, [
                      _cache[28] || (_cache[28] = _createElementVNode("div", { class: "col-md-7" }, [
                        _createElementVNode("h3", { class: "fs-4 text-white" }, " Valeurs Possibles ")
                      ], -1)),
                      _createElementVNode("div", _hoisted_36, [
                        _createElementVNode("div", _hoisted_37, [
                          _createElementVNode("button", {
                            class: _normalizeClass(["default-btn me-20 transition border-0 fw-medium text-white pt-2 pb-2 ps-8 pe-8 rounded-1 fs-md-13 fs-lg-14 bg-success", { 'cursor-not-allowed': _ctx.isDisable }]),
                            type: "button",
                            disabled: _ctx.isDisable,
                            onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.addRowValeurPossible()))
                          }, _cache[27] || (_cache[27] = [
                            _createElementVNode("i", { class: "fa fa-plus-circle position-relative ms-5 fs-12" }, null, -1),
                            _createTextVNode(" Ajouter une valeur possible ")
                          ]), 10, _hoisted_38)
                        ])
                      ])
                    ]),
                    _cache[30] || (_cache[30] = _createElementVNode("div", { class: "row align-items-center justify-content-between mt-10" }, [
                      _createElementVNode("div", { class: "col-md-5" }, [
                        _createElementVNode("label", { class: "d-block text-black fw-semibold" }, [
                          _createTextVNode(" Valeur "),
                          _createElementVNode("span", { class: "text-danger" }, "*")
                        ])
                      ]),
                      _createElementVNode("div", { class: "col-md-5" }, [
                        _createElementVNode("label", { class: "d-block text-black fw-semibold" }, [
                          _createTextVNode(" Libelle "),
                          _createElementVNode("span", { class: "text-danger" }, "*")
                        ])
                      ]),
                      _createElementVNode("div", { class: "col-md-2" }, [
                        _createElementVNode("label", { class: "d-block text-black fw-semibold" }, [
                          _createTextVNode(" Actions "),
                          _createElementVNode("span", { class: "text-danger" }, "*")
                        ])
                      ])
                    ], -1)),
                    _cache[31] || (_cache[31] = _createElementVNode("hr", { class: "mt-0" }, null, -1)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.valeurPossibles, (valeurPossible, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "row",
                        key: index
                      }, [
                        _createElementVNode("div", _hoisted_39, [
                          _createElementVNode("div", _hoisted_40, [
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": ($event: any) => ((valeurPossible.valeur) = $event),
                              type: "text",
                              class: "form-control shadow-none fs-md-15 text-black",
                              placeholder: "Saisir la valeur"
                            }, null, 8, _hoisted_41), [
                              [_vModelText, valeurPossible.valeur]
                            ]),
                            (_ctx.valideteRowValeurPossible(valeurPossible.valeur))
                              ? (_openBlock(), _createElementBlock("div", _hoisted_42, " La valeur est obligatoire. "))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_43, [
                          _createElementVNode("div", _hoisted_44, [
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": ($event: any) => ((valeurPossible.libelle) = $event),
                              type: "text",
                              class: "form-control shadow-none fs-md-15 text-black",
                              placeholder: "saisir le libellé"
                            }, null, 8, _hoisted_45), [
                              [_vModelText, valeurPossible.libelle]
                            ]),
                            (_ctx.valideteRowValeurPossible(valeurPossible.libelle))
                              ? (_openBlock(), _createElementBlock("div", _hoisted_46, " Le libellé est obligatoire. "))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_47, [
                          _createElementVNode("div", _hoisted_48, [
                            _createElementVNode("button", {
                              class: "btn btn-danger transition border-0 pb-2 ps-8 pe-8",
                              type: "button",
                              onClick: ($event: any) => (_ctx.removeRowValeurPossible(index))
                            }, _cache[29] || (_cache[29] = [
                              _createElementVNode("i", { class: "fa fa-trash-o lh-1 me-1 position-relative top-2" }, null, -1)
                            ]), 8, _hoisted_49)
                          ])
                        ])
                      ]))
                    }), 128))
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_50, [
              _createElementVNode("div", _hoisted_51, [
                _cache[33] || (_cache[33] = _createElementVNode("button", {
                  class: "btn btn-success me-3",
                  type: "submit"
                }, " Ajouter un champ libre ", -1)),
                _createVNode(_component_router_link, {
                  to: "/champsLibres/liste-champsLibre",
                  class: "btn btn-danger"
                }, {
                  default: _withCtx(() => _cache[32] || (_cache[32] = [
                    _createElementVNode("i", { class: "fa fa-trash-o lh-1 me-1 position-relative top-2" }, null, -1),
                    _createElementVNode("span", { class: "position-relative" }, null, -1),
                    _createTextVNode("Annuler ")
                  ])),
                  _: 1
                })
              ])
            ])
          ])
        ]),
        _: 1
      }, 8, ["onSubmit", "validation-schema"])
    ])
  ]))
}